<template>
    <span>
        <v-btn icon @click="requestDeleteConfirm()"
                :disabled="document.teamIsNotDeleteable(item.id)">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header"
                        :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmTeamDelete">
        </confirm-dialog>
    </span>
</template>

<script>
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import {firestore} from "../../services/db";

    export default {
        components: {
            ConfirmDialog},
        name: "saison-teams-delete",
        props: ['item', 'document'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
        }),
        methods: {
            requestDeleteConfirm(){
                this.confirmDelete.header = 'Mannschaft löschen';
                this.confirmDelete.question = "Möchtest du die Mannschaft '" + this.item.name +
                    "' wirklich endgültig löschen?";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.processDeletion();
                }
                this.confirmDelete.open = false;
            },
            async processDeletion(){
                this.document.local.documentUpdates = {
                    ['teams.' + this.item.id ]: firestore.FieldValue.delete() //+ this.item.id
                };
                let reply = await this.document.saveEdited('saison_edit');
                if ( reply.successful ) {
                    this.$store.dispatch('clearSnackbar');
                    this.$store.state.globalSnack.text = 'Die Mannschaft wurde erfolgreich gelöscht!';
                    this.$store.state.globalSnack.color = 'success';
                    this.$store.state.globalSnack.show = true;
                }
            }
        },
    }

</script>

<style scoped>

</style>